'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _Albums = require('helpers/Albums');

var _AlbumThumbDescrition = require('components/AlbumThumbDescrition/AlbumThumbDescrition');

var _AlbumThumbDescrition2 = _interopRequireDefault(_AlbumThumbDescrition);

var _Thumb = require('components/Thumb/Thumb');

var _Thumb2 = _interopRequireDefault(_Thumb);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./PlaylistAlbumCover.scss');

var PlaylistCover = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(PlaylistCover, _PureComponent);

  function PlaylistCover() {
    (0, _classCallCheck3.default)(this, PlaylistCover);
    return (0, _possibleConstructorReturn3.default)(this, (PlaylistCover.__proto__ || (0, _getPrototypeOf2.default)(PlaylistCover)).apply(this, arguments));
  }

  (0, _createClass3.default)(PlaylistCover, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          album = _props.album;


      return _react2.default.createElement(
        'div',
        { className: (0, _bind2.default)(styles.cover, className) },
        _react2.default.createElement(_Thumb2.default, { fileName: album.imageThumb, defaultImageName: (0, _Albums.getDefaultImageName)(album) }),
        _react2.default.createElement(_AlbumThumbDescrition2.default, { album: album })
      );
    }
  }]);
  return PlaylistCover;
}(_react.PureComponent), _class.propTypes = {
  album: _propTypes2.default.object,
  className: _propTypes2.default.string
}, _class.defaultProps = {
  album: {}
}, _temp);
exports.default = PlaylistCover;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Playlist/PlaylistAlbumCover/PlaylistAlbumCover.js
// module id = 2041
// module chunks = 1